import {
    DIC
} from '@/const/dic'
// import {
//     validateChinese
// } from '@/util/validate'
import {
    formatterTime
} from '@/util/util'



export const promoteDetaillOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: false,
    page: true,
    addBtn: true,
    editBtn: false,
    delBtn: false,
    columnBtn: false,
    //viewBtn: true,
    menuWidth: '200',
    labelWidth: '150',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "推广员姓名",
            prop: "name",
            type: 'input',
            span: 18
        }, {
            label: "商品名称",
            prop: "goodsName",
            type: 'input',
            span: 18
        },
        {
            label: "推广方式",
            prop: "promotionType",
            type: "select",
            dicData: DIC.PRODUCT_SHARE_TYPE,
            addVisdiplay: false,
            editVisdiplay: false,
            width: "110"
        },
        {
            label: "支付时间",
            prop: "payTime",
            type: "datetime",
            // sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        // {
        //     label: "参团时间",
        //     prop: "startDate_endDate",
        //     type: "datetimerange",
        //     search: true,
        //     hide: true,
        //     valueFormat: "timestamp",
        //     span: 24,
        //     clearable: true,
        //     formatter: function (row, value, label, column) {
        //         return formatterTime(row.startTime) + '至' + formatterTime(row.endTime)
        //     }
        // },
        // {
        //     label: "成团时间",
        //     prop: "groupTime",
        //     type: "datetime",
        //     // sortable: true,
        //     valueFormat: "timestamp",
        //     format: "yyyy-MM-dd HH:mm:ss",
        //     addVisdiplay: false,
        //     editVisdiplay: false
        // },
        // {
        //     label: "更新人",
        //     prop: "createBy",
        //     type: "input",
        //     addVisdiplay: false,
        //     editVisdiplay: false,
        //     width: "110"
        // },
    ]
};